var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarDefault = function SvgStarDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D252D",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    d: "M18.624 2.908c.507-1.21 2.245-1.21 2.752 0l3.701 8.833a3.49 3.49 0 0 0 2.942 2.124l9.608.764c1.331.106 1.844 1.737.851 2.58l-7.319 6.224a3.46 3.46 0 0 0-1.127 3.444l2.237 9.306c.3 1.252-1.08 2.288-2.228 1.592l-8.226-4.986a3.5 3.5 0 0 0-3.63 0l-8.226 4.986c-1.147.696-2.529-.34-2.228-1.592l2.237-9.306a3.46 3.46 0 0 0-1.127-3.444l-7.32-6.224c-.992-.843-.48-2.474.852-2.58l9.608-.764a3.49 3.49 0 0 0 2.942-2.124z"
  })));
};
export default SvgStarDefault;